@if (signOffForm) {
	<div class="grid grid-cols-1 gap-4 gap-y-0" [formGroup]="signOffForm">
		<div class="form-element">
			<mat-label for="form-name">Staff Id</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive mt-1 w-full">
				<input
					type="text"
					matInput
					placeholder=""
					maxlength="7"
					formControlName="staffNumber"
					[readonly]="isStaffNumberLocked"
				/>
				@if (staffNumber.errors) {
					<mat-error>
						{{ sharedService.getErrorMessage(staffNumber) }}
					</mat-error>
				}
			</mat-form-field>
		</div>
		<div class="form-element">
			<mat-label for="form-name">Sign Off PIN</mat-label>
			<mat-form-field appearance="outline" class="form-field-responsive form-field-responsive mt-1 w-full">
				<input
					[type]="!showSecret ? 'password' : 'text'"
					matInput
					(keypress)="customValidationService.allowOnlyNumbers($event)"
					placeholder=""
					maxlength="6"
					formControlName="secretKey"
				/>
				<mat-icon (click)="showHideSecret()" class="cursor-pointer" matSuffix>
					{{ !showSecret ? "visibility_off" : "visibility" }}
				</mat-icon>
				@if (secretKey.errors) {
					<mat-error>
						{{ sharedService.getErrorMessage(secretKey) }}
					</mat-error>
				}
			</mat-form-field>
		</div>
	</div>
}
